<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'single'" :company="selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Guards' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Crear guarda </h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre *</label>
            <input v-model="user.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>Apellido *</label>
            <input v-model="user.lastName" placeholder="Apellido"/>
          </div>
          <div class="form_input">
            <label>Número de cédula *</label>
            <input  v-model="user.cc" placeholder="Número de cédula"/>
          </div>
          
          <div class="form_input">
            <label>ID Carné</label>
            <input v-model="user.id" placeholder="Id carné"/>
          </div>
          <div class="form_input" v-if="getRol() == 'admin' || getRol() == 'coord'">
            <label>Empresa *</label>
            <input style="cursor: pointer;" v-model="user.company" @click="showModal = true" placeholder="Seleccione empresa"/>
          </div> 
          
        </div>
         <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" @click.prevent="createGuard" :class="{'click':isCreated,'active': isComplete()}" :style="{width: '160px', height:'46px'}">CREAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  data(){
    return{
      isCreated:false,
      user: {
        name: '',
        lastName: '',
        cc: '',
        id: '',
        company: '',
      },
      errorMessage:"",
      showModal: false,
      selectedCompany:{},
      isInError: false,
    }
  },
  methods:{
    
      createGuard(){
        if(this.user.id.length<=0){
          this.user.id=this.user.cc;
        }
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
          create: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
        };
        this.resource= this.$resource('guards/users',{},customActions);
        this.resource.create({
          "user": {"id_card": this.user.cc, "card_company": this.user.id,"name": this.user.name, "last_name": this.user.lastName},
          company_id: this.user.company == null ? null : this.selectedCompany.id
        })
        .then(function(data){
          console.log(data)
          this.$router.push({ name: 'Guards' });
        }).catch(function(err){
          var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de cédula ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
          }
        });
      },
      isComplete(){
        if(this.user.name!='' && this.user.lastName!='' && this.user.cc!='' && this.user.email!=''){
          return true;
        }
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.showModal = false;
        this.selectedCompany = value;
        this.user.company = value.name;
        
      },
      
  },
  created(){
      
      
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateGuard.vue